import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { show_meeting_data } from "../../api/User";
import { Modal, Row, Col, Select } from "antd";
import "../Admin/table.css";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { getDistrict, getBlockByDistrict, getVillageByBlock } from '../../api/User';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import TablePagination from '@mui/material/TablePagination';
import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import Swal from 'sweetalert2';

const { Option } = Select;
const ViewMeetingForGramPanchayatAdmin = ({ dateFilter }) => {
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const role_id = sessionStorage.getItem("role_id");
  const [meetingData, setMeetingData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [selectedGramPanchayat, setSelectedGramPanchayat] = useState(null);
  const [district, setDistrict] = useState([]);
  const [selectedDistrictCode, setSelectedDistrictCode] = useState('');
  const [selectedDistrictName, setSelectedDistrictName] = useState('');
  const [selectedBlockCode, setSelectedBlockCode] = useState('');
  const [selectedBlockName, setSelectedBlockName] = useState('');
  const [selectedVillage, setSelectedVillage] = useState('');
  const [block, setBlock] = useState([]);
  const [village, setVillage] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const fetchData = async () => {
    const data = {
      meeting_type: "gram_panchayat",
    };
    try {
      const res = await show_meeting_data(token, data, 1, 10, dateFilter);
      if (res.status === "success") {
        const formattedData = res.data.map((item) => {
          const [hours, minutes] = item.sabha_start_time.split(':');
          const formattedStartTime = `${hours}:${minutes}`;
          return {
            ...item,
            sabha_date: new Date(item.sabha_date).toISOString().split("T")[0],
            sabha_start_time: formattedStartTime,
          };
        });
        setMeetingData(formattedData);
        setFilteredData(formattedData);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  useEffect(() => {
    fetchData();
    fetchDistrict();
  }, []);
  useEffect(() => {
    let filtered = meetingData;
    if (selectedDistrict) {
      filtered = filtered.filter((item) => item.district === selectedDistrict);
    }
    if (selectedBlock) {
      filtered = filtered.filter((item) => item.block === selectedBlock);
    }
    if (selectedGramPanchayat) {
      filtered = filtered.filter(
        (item) => item.gram_panchayat === selectedGramPanchayat
      );
    }
    setFilteredData(filtered);
  }, [selectedDistrict, selectedBlock, selectedGramPanchayat, meetingData]);
  const handleViewMember = (row) => {
    setSelectedMember(row);
    setVisible(true);
  };
  const handleCloseModal = () => {
    setVisible(false);
    setSelectedMember(null);
  };
  const openBase64File = (base64String, fileName) => {
    if (!base64String) {
      Swal.fire({
        icon: 'error',
        title: 'File Not Uploaded',
        text: 'No file available for this entry.',
        confirmButtonText: 'OK'
      });
      return;
    }

    if (fileName.endsWith(".pdf")) {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } else if (fileName.endsWith(".docx")) {
      const docxData = `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${base64String}`;
      window.open(docxData, "_blank");
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Unsupported File Type',
        text: 'This file format is not supported for viewing.',
        confirmButtonText: 'OK'
      });
    }
  };
  
  const handleDistrictChange = (event) => {
    const selectedCode = event.target.value;
    const selectedDistrict = district.filter((item) => item.district_code == selectedCode);
    setSelectedDistrictCode(selectedCode);
    setSelectedBlockCode('');
    setSelectedVillage('');
    setBlock([]);
    setVillage([]);
    if (selectedCode) {
      fetchBlockByDistrict(selectedCode);
    }
    if (selectedDistrict) {
      setSelectedDistrictName(selectedDistrict[0].district);
    }
  };
  const handleBlockChange = (event) => {
    const selectedCode = event.target.value;
    const selectedBlock = block.filter((item) => item.block_code == selectedCode);
    setSelectedBlockCode(selectedCode);
    setSelectedVillage('');
    setVillage([]);
    if (selectedCode) {
      fetchVillageByBlock(selectedDistrictCode, selectedCode);
    }
    if (selectedBlock) {
      setSelectedBlockName(selectedBlock[0].block);
    }
  };
  const handleVillageChange = (event) => {
    const selectedCode = event.target.value;
    setSelectedVillage(selectedCode);
  };
  const fetchDistrict = async () => {
    try {
      const res = await getDistrict(token);
      if (res.status === 'success') {
        setDistrict(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching district data:', error);
      toast.error('An error occurred while fetching district data.', { autoClose: 1000 });
    }
  };
  const fetchBlockByDistrict = async (districtCode) => {
    try {
      const res = await getBlockByDistrict(token, districtCode);
      if (res.status === 'success') {
        setBlock(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching block data:', error);
      toast.error('An error occurred while fetching block data.', { autoClose: 1000 });
    }
  };
  const fetchVillageByBlock = async (districtCode, blockCode) => {
    try {
      const res = await getVillageByBlock(token, districtCode, blockCode);
      if (res.status === 'success') {
        setVillage(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching village data:', error);
      toast.error('An error occurred while fetching village data.', { autoClose: 1000 });
    }
  };
  const filteredRecords = filteredData.filter((row) => {
    let districtMatch = true;
    let blockMatch = true;
    let villageMatch = true;
    if (selectedDistrictCode) {
      districtMatch = row.district === selectedDistrictName;
    }
    if (selectedBlockCode) {
      blockMatch = row.block === selectedBlockName;
    }
    if (selectedVillage) {
      villageMatch = row.gram_panchayat === selectedVillage;
    }
    if (selectedVillage) {
      return villageMatch;
    } else if (selectedBlockCode) {
      return districtMatch && blockMatch;
    } else if (selectedDistrictCode) {
      return districtMatch;
    }
    return true;
  });
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const paginatedData = filteredRecords.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <style>
        {`
          .MuiTablePagination-actions svg {
            visibility: visible !important;
            fill: #212128;  
          }
        `}
      </style>

      <div className="container-fluid" style={{ height: "91vh" }}>
        <div style={{padding: '16px', marginTop: "-17px", marginRight: "-12px", marginLeft: "-3px" }}>
          <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}>
            Gram Panchayat Scheduled Meetings
          </h2>
        </div>
        <div style={{ display: "flex", gap: "10px", margin: "20px 0", justifyContent: "flex-end", width: "100%" }}>
          <div className="sticky-top bg-white py-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex">
                <div className="me-3">
                  <select className="form-select dropdown-custom" value={selectedDistrictCode} onChange={handleDistrictChange} >
                    <option value="" disabled>Select District</option>
                    {district.map((item) => (
                      <option key={item.district_code} value={item.district_code}>
                        {item.district}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="me-3">
                  <select className="form-select dropdown-custom" value={selectedBlockCode} onChange={handleBlockChange} >
                    <option value="" disabled>Select Block</option>
                    {block.map((item) => (
                      <option key={item.block_code} value={item.block_code}>
                        {item.block}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="me-3">
                  <select className="form-select dropdown-custom" value={selectedVillage} onChange={handleVillageChange} >
                    <option value="" disabled>Select Gram Panchayat</option>
                    {village.map((item) => (
                      <option key={item.village_code} value={item.village_code}>
                        {item.gram_panchayat}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ overflowX: "auto", maxHeight: "70vh", marginTop: "20px" }}>
          <Table aria-label="simple table">
            <TableHead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "rgb(232 233 246)", whiteSpace: "nowrap" }}>
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> SR NO.</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> DISTRICT</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> BLOCK</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> GRAM PANCHAYAT</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> DATE</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> TIME</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> PRESIDING  OFFICER NAME</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> PRESIDING  OFFICER MOBILE</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> PRESIDING  OFFICER DESIGNATION</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> VENUE</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> AGENDA</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> Members</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={11} align="center"> No data found </TableCell>
                </TableRow>
              ) : (
                paginatedData.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{index + 1 + (page * rowsPerPage)}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.district}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.block}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.gram_panchayat}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.sabha_date}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.sabha_start_time}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.presiding_officer_name}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.presiding_officer_mobile}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.presiding_officer_designation}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.venue}</TableCell>
                    <TableCell align="center" className="custom-class">
                      {row.agenda == null || "" ? (
                        "-----"
                      ) : (
                        <Button variant="contained" sx={{ fontSize: 15, backgroundColor: "#4763E430", color: "#4763E4", "&:hover": { backgroundColor: "#4763E4", color: "#fff" }, }}
                          onClick={() => openBase64File(row.attachment_base64, row.agenda)}
                        >
                          View
                        </Button>
                      )}
                    </TableCell>
                    <TableCell align="center" className="custom-class">
                      {(row.member_name1 == "undefined" || row.member_name1 == null || row.member_name1 == "" || row.member_name1 == "null") ? "NONE" : (
                        <Button variant="contained" sx={{ fontSize: 15, whiteSpace: "nowrap", backgroundColor: "#4763E430", color: "#4763E4", "&:hover": { backgroundColor: "#4763E4", color: "#fff" }, }} onClick={() => handleViewMember(row)}
                        >
                          View Member
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination rowsPerPageOptions={[5, 10, 25]} component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} showFirstButton showLastButton components={{ FirstPageIcon: FirstPage, LastPageIcon: LastPage, NextPageIcon: KeyboardArrowRight, BackPageIcon: KeyboardArrowLeft, }} />
        <Modal className="mt-5" title={<h2 style={{ margin: 0 }}>Member Details</h2>} visible={visible} onCancel={handleCloseModal} footer={null} width={1200} centered zIndex={1050}   >
          {selectedMember ? (
            Object.values(selectedMember).some(member => member) ? (
              <Row gutter={16} style={{ padding: '20px' }}>
                <Col span={8}>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px', fontWeight: '500' }}>Member 1</div>
                    <div style={{ fontSize: '18px' }}>Name : {selectedMember.member_name1 || "N/A"}</div>
                    <div style={{ fontSize: '18px' }}>Phone : {selectedMember.member_ph_no1 || "N/A"}</div>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px', fontWeight: '500' }}>Member 2</div>
                    <div style={{ fontSize: '18px' }}>Name : {selectedMember.member_name2 || "N/A"}</div>
                    <div style={{ fontSize: '18px' }}>Phone : {selectedMember.member_ph_no2 || "N/A"}</div>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px', fontWeight: '500' }}>Member 3</div>
                    <div style={{ fontSize: '18px' }}>Name : {selectedMember.member_name3 || "N/A"}</div>
                    <div style={{ fontSize: '18px' }}>Phone : {selectedMember.member_ph_no3 || "N/A"}</div>
                  </div>
                </Col>
              </Row>
            ) : (
              <div style={{ textAlign: 'center', padding: '20px' }}>No data found</div>
            )
          ) : null}

          {selectedMember && (
            <Row gutter={16} style={{ padding: '20px' }}>
              <Col span={8}>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '20px', fontWeight: '500' }}>Member 4</div>
                  <div style={{ fontSize: '18px' }}>Name : {selectedMember.member_name4 || "N/A"}</div>
                  <div style={{ fontSize: '18px' }}>Phone : {selectedMember.member_ph_no4 || "N/A"}</div>
                </div>
              </Col>
              <Col span={8}>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '20px', fontWeight: '500' }}>Member 5</div>
                  <div style={{ fontSize: '18px' }}>Name : {selectedMember.member_name5 || "N/A"}</div>
                  <div style={{ fontSize: '18px' }}>Phone : {selectedMember.member_ph_no5 || "N/A"}</div>
                </div>
              </Col>
            </Row>
          )}
        </Modal>
        <ToastContainer />
      </div>
    </>
  );
};
export default ViewMeetingForGramPanchayatAdmin;
